import { useCallback, useState } from 'react';

import type { QuestionNumber } from '../../constants';

type Result = {
	// which question's answer is expanded, or null if all are collapsed
	expandedQuestion: QuestionNumber | null;
	handleQuestionToggle: (questionNumber: QuestionNumber, expanded: boolean) => void;
};

/**
 * Single-open state for the video question accordions: storing one expanded question rather than a set
 * means expanding a row implicitly collapses whichever was open. Question 1 starts expanded.
 */
export function useExpandedQuestion(): Result {
	const [expandedQuestion, setExpandedQuestion] = useState<QuestionNumber | null>(1);

	const handleQuestionToggle = useCallback((questionNumber: QuestionNumber, expanded: boolean) => {
		setExpandedQuestion(expanded ? questionNumber : null);
	}, []);

	return { expandedQuestion, handleQuestionToggle };
}
